import {
  Debounce,
  GlobalEvents,
  SnippetElement,
  defineElement,
  globalOn,
  onClick,
  param,
  query
} from "./chunk-DVEUW3FQ.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/common-search-modal/common-search-modal.ts
var _a, _b;
var CommonSearchModal = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.baseUrl = `${(_b = (_a = window == null ? void 0 : window.Shopify) == null ? void 0 : _a.routes) == null ? void 0 : _b.root}`;
  }
  closeSearchModal() {
    var _a2;
    (_a2 = this.searchModal) == null ? void 0 : _a2.close();
  }
  get loading() {
    var _a2, _b2;
    return (_b2 = (_a2 = this.resultBar) == null ? void 0 : _a2.hasAttribute("loading")) != null ? _b2 : false;
  }
  set loading(val) {
    var _a2, _b2;
    if (val) {
      (_a2 = this.resultBar) == null ? void 0 : _a2.setAttribute("loading", "");
    } else {
      (_b2 = this.resultBar) == null ? void 0 : _b2.removeAttribute("loading");
    }
  }
  connectedCallback() {
    var _a2, _b2;
    const debouncedRender = Debounce.debounce(() => {
      this.fetchPredictiveSearch();
    }, (_a2 = this.time) != null ? _a2 : 800);
    (_b2 = this.predictiveSearch) == null ? void 0 : _b2.addEventListener("input", () => {
      var _a3;
      this.loading = true;
      (_a3 = this.resultBar) == null ? void 0 : _a3.classList.remove("hidden");
      debouncedRender();
    });
  }
  resetInput() {
    var _a2, _b2;
    (_a2 = this.predictiveSearch) == null ? void 0 : _a2.setAttribute("value", "");
    this.output.innerHTML = "";
    this.predictiveSearch.value = "";
    (_b2 = this.resultBar) == null ? void 0 : _b2.classList.add("hidden");
    this.loading = false;
  }
  fetchPredictiveSearch() {
    return __async(this, null, function* () {
      var _a2, _b2, _c;
      if (((_a2 = this.predictiveSearch) == null ? void 0 : _a2.value) === "") {
        this.resetInput();
        return;
      }
      const response = yield fetch(`${this.baseUrl}search/suggest?q=${(_b2 = this.predictiveSearch) == null ? void 0 : _b2.value}&resources[type]=product&section_id=ajax-search`);
      if (response.status == 422) {
        this.loading = false;
        return;
      }
      const text = yield response.text();
      const html = document.createElement("div");
      html.innerHTML = text;
      if (this.output) {
        this.output.innerHTML = html.innerHTML;
      }
      this.loading = false;
      (_c = this.resultBar) == null ? void 0 : _c.classList.add("hidden");
      GlobalEvents.emit("recommendation:performed");
    });
  }
  showResults() {
    var _a2, _b2, _c;
    (_a2 = this.resultBar) == null ? void 0 : _a2.classList.remove("hidden");
    this.resultSize.innerHTML = (_c = (_b2 = this.output) == null ? void 0 : _b2.querySelectorAll("[data-result]").length.toString()) != null ? _c : "0";
  }
};
__decorateClass([
  query("[data-output]")
], CommonSearchModal.prototype, "output", 2);
__decorateClass([
  query("[data-predictive-search]")
], CommonSearchModal.prototype, "predictiveSearch", 2);
__decorateClass([
  query("[data-result-bar]")
], CommonSearchModal.prototype, "resultBar", 2);
__decorateClass([
  query("[data-result-size]")
], CommonSearchModal.prototype, "resultSize", 2);
__decorateClass([
  param()
], CommonSearchModal.prototype, "time", 2);
__decorateClass([
  query("[search-modal]")
], CommonSearchModal.prototype, "searchModal", 2);
__decorateClass([
  globalOn("cart:open")
], CommonSearchModal.prototype, "closeSearchModal", 1);
__decorateClass([
  onClick("[data-input-reset]")
], CommonSearchModal.prototype, "resetInput", 1);
__decorateClass([
  globalOn("recommendation:performed")
], CommonSearchModal.prototype, "showResults", 1);
CommonSearchModal = __decorateClass([
  defineElement()
], CommonSearchModal);
export {
  CommonSearchModal
};
